import { render, staticRenderFns } from "./GatewayUrlForm.vue?vue&type=template&id=52c78d18&"
import script from "./GatewayUrlForm.vue?vue&type=script&lang=js&"
export * from "./GatewayUrlForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports